// src/pages/micro-exercises/MicroExerciseDetailPage.js

import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import OuterHeader from "../../components/OuterHeader";
import Footer from "../../components/Footer";

import { MICRO_EXERCISE_CATEGORIES } from "../../data/microExercisesData";

import HelprrSensoryGrounding from "../../components/HelprrSensoryGrounding.jsx";
import HelprrBodyExercise from "../../components/HelprrBodyExercise.jsx";
import HelprrBoxBreath from "../../components/HelprrBoxBreath.jsx";
import HelprrNameThreeThings from "../../components/HelprrNameThreeThings.jsx";
import HelprrPanicAnchor from "../../components/HelprrPanicAnchor.jsx";
import SlowDownList from "../../components/SlowDownList.jsx";
import HelprrVagusHum from "../../components/HelprrVagusHum.jsx";

// Map component IDs → actual components
const COMPONENT_MAP = {
  HelprrSensoryGrounding,
  HelprrBodyExercise,
  HelprrBoxBreath,
  HelprrNameThreeThings,
  HelprrPanicAnchor,
  SlowDownList,
  HelprrVagusHum,
};

export default function MicroExerciseDetailPage() {
  const { exerciseId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Did the user arrive from Capsules list?
  const fromCapsules = location.state?.from === "capsules";

  // Find exercise data
  let exercise = null;
  MICRO_EXERCISE_CATEGORIES.forEach((cat) => {
    cat.exercises.forEach((ex) => {
      if (ex.id === exerciseId) exercise = ex;
    });
  });

  return (
    <>
      <OuterHeader />

      <div className="exercise-detail-wrapper" style={{ paddingTop: "40px" }}>
        {/* BACK BUTTON (only when user came from /micro-exercises) */}
        {fromCapsules && (
          <button
            onClick={() => navigate(-1)}
            className="caps-back-btn"
            style={{
              margin: "0 0 20px 20px",
              padding: "10px 16px",
              borderRadius: "10px",
              background: "rgba(255, 150, 100, 0.12)",
              border: "1px solid rgba(255, 150, 100, 0.35)",
              color: "#d45a2c",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "0.2s ease",
            }}
          >
            ← Back to Capsules
          </button>
        )}

        {!exercise ? (
          <h2>Exercise not found</h2>
        ) : (
          <>
            {/* Render ONLY the interactive component */}
            {exercise.componentId && COMPONENT_MAP[exercise.componentId] ? (
              React.createElement(COMPONENT_MAP[exercise.componentId])
            ) : (
              <p>This exercise will be interactive soon.</p>
            )}
          </>
        )}
      </div>

      <Footer />
    </>
  );
}
